<template>
    <div><!-- 試作準備 - 檔案上傳+審核 -->
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-end mb-2">
                    <button class="btn btn-sm btn-success" v-if="canSave" @click="savedDataEvent()">{{$t('Buttons.Confirm')}}</button>
                    <button class="btn btn-sm btn-dark ml-2" @click="goBackFix()">{{$t('Buttons.GoBack')}}</button>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="title left" :class="{changeEn: lang === 'en'}">{{ i18n("TrialProduction.Machine") }}</div>
                        <div class="content">{{trialItemRow.roeModel}}</div>
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{changeEn: lang === 'en'}">{{ i18n("TrialProduction.Phase") }}</div>
                        <div class="content">{{trialItemRow.developPhase}}</div>
                    </div>
                    <div class="col-md-6">
                        <div class="title left" :class="{changeEn: lang === 'en'}">{{ i18n("TrialProduction.Part") }}</div>
                        <div class="content">{{trialItemRow.partnumber}}</div>
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{changeEn: lang === 'en'}">{{ i18n("TrialProduction.Vendor") }}</div>
                        <div class="content">{{trialItemRow.customerName}}</div>
                    </div>
                    <div v-if="isNewStatementDocBtnShow" class="col-md-12">
                        <div class="title" :class="{changeEn: lang === 'en'}">申明書　</div>
                        <div class="content"><button class="btn btn-sm btn-success" @click="newStatementDocEvent">新機種轉量產申明書</button></div>
                    </div>
                    <div class="col-md-6">
                        <div class="title left" :class="{changeEn: lang === 'en'}" style="min-width: 98px;">
                            {{i18n("TrialProduction.Action") }}
                            <button class="btn btn-sm btn-danger" v-if="canEdit" @click="addRowEvent">+</button>
                        </div>
                        <div class="file-content">
                            <div v-for="(it) in trialItemRow.itemFileList" :key="'itemRowFileLink_input_' + it.fileGuid">
                                <input type="file" v-if="canEdit" style="width:300px;" @change="onFileSelection($event , it )">                             
                                <a class="fileLink" v-if="showFileLink(it)" target="_blank" :href="getFileLink(it)">{{getFileName(it)}}</a>
                                <button class="btn btn-sm btn-danger" v-if="canEdit" @click="deleteRowEvent(it)">-</button>
                            </div>
                        </div>                        
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{changeEn: lang === 'en'}">{{ i18n("TrialProduction.Audit") }}</div>
                        <div class="content radio_container"  v-if="showConfirmUI">
                            <span v-for="(item, key) in planStatusListFilter" :key="'itemRowStatus_input_' + key">
                                <input type="radio" :name="'item_RowStatusOpt'" v-model="trialItemRow.itemStatus" :value="item.planStatusId" >{{item.planStatusCaption}}
                            </span>                      
                        </div>
                        <div class="content radio_container" v-else>
                            <span style="display: inline-block;margin-right:10px;">{{trialItemRow.itemStatusTxt}}</span>
                            <button class="btn btn-sm btn-success mr-2" v-if="canReboot" @click="rebootEvent()">{{i18n("TrialProduction.Reboot")}}</button>
                        </div>                        
                    </div>
                    <div class="col-md-12" >
                        <div class="title">{{i18n("TrialProduction.AuditDescription") }}</div>
                        <div class="content" v-if="!isMember">
                            <textarea cols="20" rows="10" v-model="trialItemRow.itemMemo"></textarea>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center">{{ i18n("TrialProduction.LOGTime") }}</th>
                                    <th class="text-center">{{ i18n("TrialProduction.AuditDescription") }}</th>
                                    <th class="text-center">{{ i18n("TrialProduction.Status") }}</th>
                                    <th class="text-center">{{ i18n("TrialProduction.AssigneeOfUpdate") }}</th>
                                    <th class="text-center">{{ i18n("TrialProduction.CorrespondingType") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item , index) in trialItemLogRows" :key="index">
                                    <td class="text-center">{{fixDateTime(item.logDate)}}</td>
                                    <td class="text-center">{{item.logMemo}}</td>
                                    <td class="text-center">{{getLogStatusTxt(item.logStatus)}}</td>
                                    <td class="text-center">{{item.logCreateusername}}</td>
                                    <td class="text-center">{{item.logItemType}}                                        
                                        <div v-html="getHistoryFileLink(item)"></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </CCardBody>
        </CCard>
         <!-- Modal 新機種轉量產申明書 資料顯示--> 
        <div class="modal fade" id="newStatementDocModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        新機種轉量產申明書
                    </div>
                    <div class="modal-body">
                        <div>
                            <span>機種名：</span><span class="inputSpan">{{trialItemRow.roeModel}}</span>
                        </div>
                        <div>
                            <span>部材料號：</span><span class="inputSpan">{{trialItemRow.partnumber}}</span>
                        </div>
                        <div>
                            <span>供應商：</span><span class="inputSpan">{{trialItemRow.customerName}}</span>
                        </div>
                        <div class="msg01">
                            新機種各階段(T0/ES/CS)試作資料已上傳至瑞儀光電(ROE)供應商管理系統                        
                        </div>
                        <div class="msg01">
                            (系統網址：<a href="https://suponline.radiant.com.tw/SUP/Login.aspx">https://suponline.radiant.com.tw/SUP/Login.aspx</a>)
                        </div>
                        <div class="msg02">
                            已確認系統中下列上傳項目資料正確無誤，我司將以此條件水準進行量產
                            如有變更情況，會主動通知瑞儀SQE
                        </div>
                        <div>
                            <table class="itemListTable">
                            <thead>
                                <th>階段</th>
                                <th>項目</th>
                                <th>確認結果</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item , index) in newStatementItemList" :key="index">
                                    <td class="reply">{{item.developPhase}}</td>
                                    <td class="reply">{{item.itemTxt}}</td>                                    
                                    <td class="reply">
                                        <a :href="itemStatusLinkEvent(item)" target="_blank"  v-if="isItemStatusLink(item)">{{item.itemStatusTxt}}</a>
                                        <span v-else>{{item.itemStatusTxt}}</span>
                                    </td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                        <div>
                            <span>立申明書人：</span><span class="inputSpan">{{emptyStringInTag}}</span>
                        </div>
                        <div>
                            <span>工廠最高主管:</span><span class="inputSpan">{{emptyStringInTag}}</span>
                        </div>
                        <div>
                            <span>品質主管:</span><span class="inputSpan">{{emptyStringInTag}}</span>
                        </div>                        
                        <div>
                            <span>採購主管:</span><span class="inputSpan">{{emptyStringInTag}}</span>
                            <span>公司印章:</span><span class="inputSpan">{{emptyStringInTag}}</span>
                        </div>   
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-gray" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                        <button type="button" class="btn btn-dark" @click="downloadNewStatementPdf">下載新機種轉量產申明書</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {
            trialItemRow : {itemFileList:[]},
            trialItemLogRows : [],
            newStatementItemList : []
        }
    },
    props : {
    },
    methods: {
        getDetail (trialItemKeys){
            if(!trialItemKeys) return;            
            if(trialItemKeys.indexOf('\t') === -1) return;
            const self = this;
            const p = trialItemKeys.split('\t');
            const params = {pid : p[0] , dtlGuid:  p[2]};
            const url = `${this.$apiUrl_Quality}/GetTrialItemDetail`;
            this.updateLoading(true);            
            this.axios.get(url , {params}).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功                                    
                    const rtRows = response.data;                     
                    self.trialItemLogRows = rtRows.planDtlItemLogList;   
                    rtRows.planDtlItemLogList = null;                 
                    rtRows.oldItemStatus = rtRows.itemStatus;
                    //rtRows.hadFilename = rtRows.itemFile;
                    rtRows.itemStatusTxt = self.getLogStatusTxt (rtRows.itemStatus);
                    self.trialItemRow = rtRows;
                    if(!rtRows.itemFileList){
                        rtRows.itemFileList = [];
                    }
                    if(rtRows.itemFileList.length ===0){
                        const timestamp = new Date().getTime() + '';
                        rtRows.itemFileList.push({"fileGuid": timestamp ,"dtlGuid" : "" ,"logGuid": "" ,"filename": "","fileBase64" :""});
                    }
                    if(self.canSave){
                        rtRows.itemMemo = '';
                    }
                    if(self.isMember && rtRows.itemStatus === 4){// 供應商且未上傳，清空說明欄位
                        rtRows.itemMemo = ' ';//廠商不需要填寫審核說明
                    }
                }                                
            }); 
        },
        getLogStatusTxt (status){
            const map =this.logStatusMap;
            let v = map[status];
            if(v){
                return v;
            }
            return '';
        },
        onFileSelection (e , it) { //--檔案挑選後，判斷並處理此檔案物件
            const maxFileByte = 5242880;            
            const acceptedImageTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/pdf'];
            // add all selected files
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return false;
            //const self = this;
            let file = files[0];
            let fileType = file['type'];
            let isAccpetType = acceptedImageTypes.includes(fileType);
            it.filename = '';
            it.fileBase64 = null;
            if (!isAccpetType) {                
                e.target.value = '';
                this.$alert('檔案格式需為 Excel (Excel 2007 以上版本)/ PDF，請重新上傳!','警告',{type: 'warning'});                     
            } else if (maxFileByte < file.size) {
                e.target.value = '';
                this.$alert('檔案大小需5Mb以下，請重新上傳!','警告',{type: 'warning'});                
            } else {                
                const reader = new FileReader();
                reader.readAsDataURL(file);                                 
                reader.onload = function(event) {
                    const itemBase64result = reader.result.substr(event.target.result.indexOf(',') + 1);
                    if(itemBase64result) {
                        it.filename = file.name;
                        it.fileBase64 = itemBase64result;
                    }
                };
            }
        },
        showFileLink (it){
            if(it.fileGuid && it.fileGuid.length >30){
                return true;
            }
            return false;
        },
        getFileLink (it){
            const baseUrl = this.$apiUrl_Quality;
            const pid= this.trialItemRow.pid;
            if(it.fileGuid){
                return `${baseUrl}/PlanItemDownload/${pid}/${it.dtlGuid}/${it.fileGuid}`;
            }
        },
        getFileName (it){
            if(it.fileGuid){
                return this.fixFileName(it.filename);
            }
            return '';
        },
        checkSaveData (){ //檢核必要儲存資料
            const chkRow= this.trialItemRow;                     
            if(this.isMember){
                if(chkRow.itemFileList){
                    let numFiles = 0 ;
                    chkRow.itemFileList.forEach(r=>{
                        if((r.filename && r.fileBase64) || r.fileGuid){
                            numFiles +=1;
                        }
                    })
                    if(numFiles === 0){
                        this.$alert('必需上傳檔案！','警告',{type: 'warning'});
                        return false;
                    }
                }
            }else{
                //品質人員/品質管理者
                if(chkRow.itemStatus != 1 && chkRow.itemStatus != 2 && chkRow.itemStatus != 3 && chkRow.itemStatus != 5){
                    this.$alert('請選擇一個審核狀態！','警告',{type: 'warning'});
                    return false;
                }
            }
            if(!chkRow.itemMemo){
                this.$alert('審核說明為必要輸入資料！','警告',{type: 'warning'});
                return false;
            }
            return true;
        },
        savedDataEvent (){
            if(!this.checkSaveData()) return;             
            if(this.isMember){// 供應商僅能設為 0待判定
                this.trialItemRow.itemStatus = 0;
            }
            const url = `${this.$apiUrl_Quality}/UpdatePlanItemRow`;
            const param = this.trialItemRow;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功    
                    this.goBackFix();
                }                    
            }); 
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
        rebootEvent (){
            const status = this.trialItemRow.oldItemStatus;
            if(!this.isMember && status === 1){
                const chkRow= this.trialItemRow;
                chkRow.itemMemo = '重啟案件';
                chkRow.itemStatus = 5;
                this.savedDataEvent ()
            }
        },
        addRowEvent (){
            if(this.isMember && this.canEdit) {
                const chkRow= this.trialItemRow;
                const arr = chkRow.itemFileList;
                if(arr.length > 9){
                    this.$alert('最多僅能上傳 10個檔案','警告',{type: 'warning'});
                    return;
                }
                const timestamp = new Date().getTime() + '';
                chkRow.itemFileList.push({"fileGuid": timestamp ,"dtlGuid" : "" ,"logGuid": "" ,"filename": "","fileBase64" :"" }); 
            }
        },        
        deleteRowEvent (it){
            if(this.isMember && this.canEdit) {
                const chkRow= this.trialItemRow;
                const arr = chkRow.itemFileList;
                if(arr.length < 2){
                    this.$alert('至少需要上傳一個檔案','警告',{type: 'warning'});
                    return;
                }                
                var index = arr.map(function(e) { return e.fileGuid; }).indexOf(it.fileGuid);
                if (index > -1) {
                    arr.splice(index, 1);
                }
            }
        },
        getHistoryFileLink (item){
            const listLinks = [];
            const baseUrl = this.$apiUrl_Quality;
            const pid= this.trialItemRow.pid;
            const historyDic = this.trialItemRow.historyPlanFiles;            
            if(historyDic && historyDic[item.logGuid]){
                const oldFileList = historyDic[item.logGuid];
                if(oldFileList && oldFileList.length >0){
                    oldFileList.forEach(it=> {
                        listLinks.push(`<a class="fileLink" target="_blank" href="${baseUrl}/PlanItemDownload/${pid}/${it.dtlGuid}/${it.fileGuid}">${it.filename}</a>`);
                    });
                }                
            }
            if(listLinks.length >0){
                return listLinks.join(',');
            }else{
                return '';
            }

        },
        newStatementDocEvent (){ //點選 新機種轉量產申明書
            this.newStatementItemList = [];
            const pid = this.trialItemRow.pid;
            const dtlGuid = this.trialItemRow.dtlGuid;
            const url = `${this.$apiUrl_Quality}/GetNewStatementItemList/${pid}/${dtlGuid}`;
             this.axios.get(url , {}).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功
                    this.newStatementItemList = response.data;
                    this.jqModalShow('newStatementDocModal');
                }                                
            }); 
            
        },
        isItemStatusLink(it){
            if(!it) return false;
            if( !it.pid ||  !it.dtlGuid){
                return false;
            }
            return true;
        },
        itemStatusLinkEvent (item){
            if(item && item.dtlGuid){
                //debugger;
                const trialItemKeys = item.pid + '_' + item.seqno + '_' + item.dtlGuid ;
                // sessionStorage.setItem('trialItemKeys', trialItemKeys);
                // location.reload();
                return '#/iteminformation?trialItemKeys=' + trialItemKeys;
            }
            return '#'
        },
        downloadNewStatementPdf () {//點選 下載新機種轉量產申明書
            const url = `${this.$apiUrl_Quality}/PrepareNewStatementPdf`;
            const param= {
                pid : this.trialItemRow.pid ,
                dtlGuid : this.trialItemRow.dtlGuid ,
                roeModel : this.trialItemRow.roeModel,
                developPhase : this.trialItemRow.developPhase,
                partnumber : this.trialItemRow.partnumber,
                customerName : this.trialItemRow.customerName
            };
            this.axios.post(url, param).then((response) => {                        
                const respObj = response.data;                 
                const token = respObj.token;
                let urlExcel = `${this.$apiUrl_Print}/PrintNewStatementPdf/${token}`;
                this.openNewTabByALink('PrintNewStatementPdf',urlExcel);
            })
        },
        goBackFix(){            
            const trialKeys = sessionStorage.getItem('trialKeys');
            if(trialKeys){
                this.$router.push('information'); //this.goBack();
            }else{
                this.$router.push('trialproduction');
            }
        }
    },
    computed: {
        ...mapGetters(["lang"]),
        planStatusList (){
            return this.$t('planStatusList');
        },
        planStatusListFilter (){
            const list = [];            
            if(this.planStatusList && this.planStatusList.length >0){
                this.planStatusList.forEach(r=>{
                    if(r.planStatusId && r.planStatusId !== 4 && r.planStatusId !== 5){
                        list.push(r);
                    }                  
                });
            }
            return list;
        },        
        logStatusMap (){
            return this.listToMap(this.planStatusList, 'planStatusId' ,'planStatusCaption');
        },
        showConfirmUI (){
            const status = this.trialItemRow.oldItemStatus;
            if(status === 1){
                return false;//已完成案件都不需處理
            }
            if(this.isMember){
                return false;//供應商不需提供
            }else{
                //品質人員都可使用
            }
            return true;
        },
        canEdit (){
            //0待判定(且 pt.ITEM_FILE_ISUPLOAD=1)/1-OK(完成)/2-Reject(退件)/3-Skip/4-未上傳(且 pt.ITEM_FILE_ISUPLOAD=0 )/5-Reboot
            const status = this.trialItemRow.oldItemStatus;
            if(status === 1){
                return false;//已完成案件都不需處理            }
            }
            if(this.isMember){                
                if(status === 2 || status === 4){
                    return true;
                }
            }else {
                if(status === 4){
                    return false;
                }
            }
            return false;
        },
        canSave (){
            const status = this.trialItemRow.oldItemStatus;
            if(status === 1){
                return false;//已完成案件都不需處理
            }            
            if(this.isMember){                
                if(status === 4){
                    return true;
                }
                return false;
            }else{                
                return true;
            }
        },
        canReboot(){
            const status = this.trialItemRow.oldItemStatus;
            if(!this.isMember && status === 1){
                return true;
            }
            return false;
        },
        isNewStatementDocBtnShow(){            
            if(this.trialItemRow && this.trialItemRow.developPhase === 'MP'){
                const status = this.trialItemRow.oldItemStatus;
                if(this.isMember && status === 4){ // 供應商才呈現 + 未上傳
                    return true;
                }else if(!this.isMember){//規格變更
                    return true;
                }
            }
            return false;
        },
        emptyStringInTag(){
            return '　'.repeat(10);
        }
    },
	mounted() {
        const trialItemKeys = sessionStorage.getItem('trialItemKeys');
        if(trialItemKeys){            
            this.getDetail(trialItemKeys);
        }else{
            this.goBackFix();            
        }
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.btn-edit {
    background-color: #343b55;
    color: white;
}

.row {
    padding: 0 12px;
}

.col-md-6 {
    display: flex;
    padding: 0;
    .content {
        flex: 1;
        input[type="radio"] {
            margin: 0 .2rem;
        }
    }

    .title, .content {
        display: flex;
        align-items: center;
        border: solid 1px;
        padding: .6rem 1rem;
    }

    .file-content {
        margin: 0;
        width: 100%;
        border: solid 1px;
        padding: .6rem 1rem;
    }

    .title {
        background-color: #BDD6EE;
    }
}

.col-md-12 {
    display: flex;
    padding: 0;

    .title, .content {
        display: flex;
        align-items: center;

        border: solid 1px;
        padding: .6rem 1rem;
    }

    .content {
        flex: 1;

        textarea {
            width: 100%;
            margin: 0 .5rem;
            border-radius: 6px;
        }
    }

    .file-content {
        width: 100%;
        margin: 0;
        border: solid 1px;
        padding: .6rem 1rem;
    }

    .title {
        background-color: #BDD6EE;
    }

}

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table, .table-bordered th, .table-bordered td {
    border-color: black;
}

.table th {
    // background-color: #FFC300;
    background-color: #FFD966;
    color: #000;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.left {
    padding: 0.6rem 2rem !important;
}

.changeEn {
    min-width: 163px !important;
}
div.msg01 {
    margin: 10px;
    width: 90%;
    text-align: center;
}
div.msg02 {
    margin: 10px;
    width: 90%;
    text-align: left;
    font-size: 18px;
    font-weight:900;
}
.inputSpan {
    text-decoration:underline;
    display: inline-block;
    width: 300px;
    height: 20px;
}
table.itemListTable {
    border-collapse: collapse;
    table-layout: fixed;
    width: 90%;
    margin-bottom: 20px;
}
table.itemListTable th {
    border: 1px solid black;
    width: 30%;
    text-align: center;
    vertical-align: middle;
}
table.itemListTable td {
    border: 1px solid black;
    width: 30%;
    padding-left: 6px;
}
#newStatementDocModal a {
    text-decoration : underline !important;
}
</style>
